import React from "react";

const collections = [
  {
    title: "Home",
    image:
      "https://images.unsplash.com/photo-1741879080222-b9b5f20b3333?q=80&w=2400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    title: "Footwear",
    image:
      "https://images.unsplash.com/photo-1741879080222-b9b5f20b3333?q=80&w=2400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    title: "Technology",
    image:
      "https://images.unsplash.com/photo-1741879080222-b9b5f20b3333?q=80&w=2400&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
];

export default function LandingA() {
  return (
    <div className="min-h-screen bg-white px-4 py-10">
      <div className="bg-[#f5edff] rounded-xl text-center py-20 px-4 mb-12">
        <h1 className="text-5xl font-bold text-gray-900 leading-tight mb-4">
          Curate your products <br /> into simple collections.
        </h1>
        <p className="text-gray-700 text-lg">
          Use this page to group your products into themed collections, making
          it easy for customers to explore.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {collections.map((item) => (
          <div
            key={item.title}
            className="bg-purple-50 rounded-3xl p-6 flex flex-col items-center justify-between relative shadow-lg hover:shadow-xl transition hover:scale-105 duration-300"
          >
            <h2 className="text-3xl font-semibold mb-4 text-gray-900">
              {item.title}
            </h2>
            <img
              src={item.image}
              alt={item.title}
              className="w-28 h-28 object-contain mb-6"
            />
            <button className="absolute bottom-4 right-4 w-9 h-9 rounded-full bg-white border border-gray-300 flex items-center justify-center hover:bg-purple-100 transition">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
